import { miscSections } from '@glass/web/modules/resumes/router/sections';

const isMiscSection = (section) => !!miscSections.find(({ type }) => type === section);

export default isMiscSection;
